import kotlinx.browser.window
import msw.setupMsw
import org.jetbrains.compose.web.renderComposable

fun main() {
    val promise: dynamic = try {
        setupMsw()
    } catch (error: dynamic) {
        console.error("[MSW] Mock Service Worker の初期化中に同期例外が発生:", error)
        renderApp()
        return
    }

    if (promise != null) {
        // MSW の Service Worker 起動完了を待ってからアプリを描画
        promise.then {
            console.log("[MSW] Mock Service Worker 起動完了")
            window.asDynamic().__mswStarted = true
            renderApp()
        }.catch { error: dynamic ->
            console.error("[MSW] Mock Service Worker の起動に失敗:", error)
            renderApp()
        }
    } else {
        renderApp()
    }
}

private fun renderApp() {
    renderComposable(rootElementId = "root") {
        App()
    }
}
